<script>
  import { onDestroy } from "svelte";
  import { navigationStore } from '../stores';


  let currentRoute = null;

  const unsubscribe = navigationStore.subscribe((route) => {
    currentRoute = route;
  });

  onDestroy(() => {
    unsubscribe();
  });

  const current = route => (currentRoute && currentRoute.to.name === route) || false;
</script>

<style lang="scss">
	.header {
		padding: 3em 0;
		display: flex;

		align-items: center;
		justify-content: space-between;

    figure {
      display: flex;
      align-items: flex-start;
      margin: 0;

      img {
        width: 280px;
      }
    }

    nav {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      min-width: 42em;

      ul {
        li {
          display: inline;

          a {
            text-transform: uppercase;
            font-family: 'Ubuntu', 'Montserrat', sans-serif;
            font-weight: 600;
          }

          a.current {
            text-decoration: underline;
          }
        }

        li + li a {
          padding-left: 1.2em;
        }
      }

      button {
        padding: 0.8em 2em;
        font-weight: 600;
      }
    }
	}
</style>

<header class="header">
  <a href="/"><figure><img src="assets/voltaware-logo.png" alt="Voltaware"/></figure></a>
  <nav>
    <ul class="inline">
      <li><a class="primary" class:current={current('product')} href="/product">product</a></li>
      <li><a class="primary" class:current={current('installation')} href="/installation">installation</a></li>
      <li><a class="primary" class:current={current('about')} href="/about">about</a></li>
      <li><a class="primary" class:current={current('support')} href="/support">support</a></li>
    </ul>
    <a href="/purchase"><button class="ubuntu attention golden">order now</button></a>
  </nav>
</header>
